<div [formGroup]="form">
  <div class="section">Ausstattung</div>
  <div class="grid">
    <div class="md:col-3">
      <label class="label" for="businesses">Geschäftslokale</label>
      <input id="businesses" type="text" fullWidth nbInput formControlName="businesses">
    </div>

    <div class="md:col-3">
      <label class="label" for="heatingSystem">Heizungsanlage</label>
      <input id="heatingSystem" fullWidth type="text" nbInput formControlName="heatingSystem">
    </div>

    <div class="md:col-3">
      <label class="label" for="playGround">Spielplatz</label>
      <input id="playGround" fullWidth type="text" nbInput formControlName="playground">
    </div>

    <div class="md:col-3">
      <label class="label" for="garageCount">Garagen</label>
      <input id="garageCount" min="0" step="1" type="number" nbInput fullWidth
             formControlName="garageCount">
    </div>

    <div class="md:col-3">
      <label class="label" for="undergroundGarageCount">Tiefgaragen</label>
      <input id="undergroundGarageCount" min="0" step="1" type="number" nbInput
             fullWidth formControlName="undergroundGarageCount">
    </div>

    <div class="md:col-3">
      <label class="label" for="flatCount">Anzahl der Wohnungen</label>
      <input id="flatCount" min="0" type="number" nbInput formControlName="flatCount" fullWidth>
    </div>

    <div class="md:col-3">
      <label class="label" for="convertedAttic">Ausgebautes Dachgeschoß</label>
      <wr-building-attic-select id="convertedAttic" formControlName="convertedAttic"></wr-building-attic-select>
    </div>
  </div>
</div>
